export const urls = {
  prod: {
    link: "https://gestao-amei.sebrae.com.br/",
    token: "413ba951-88ae-4d75-a8f5-7fc84822b353"
  },
  homolog: {
    link: "https://gestao-amei.homolog.kubernetes.sebrae.com.br/",
    token: "413ba951-88ae-4d75-a8f5-7fc84822b353"
  },
  desenv: {
    link: "https://gestao-amei.homolog.kubernetes.sebrae.com.br/",
    token: "413ba951-88ae-4d75-a8f5-7fc84822b353"
  }
}